/** Quick and dirty way to change the build. */
/* Changed by ../build/parula-brand.sh . That's also why we use '' quotes here. */
export const production = true;
export const appVersion: string = '0.9.15-dev';
export const appName: string = 'Mustang';
export const siteRoot: string = 'https://mustang.im';
export const isMobile = false;
export const webMail = 'JMAP';
export const includeProprietary = true;
